import { ReactElement } from "react";
import { LinkProps } from "@tanstack/react-router";
import {
  AppWindow,
  BarChart3,
  Calendar1,
  Combine,
  Copy,
  MonitorCheck,
  NotebookPen,
  ReceiptText,
  Settings,
  TableProperties,
} from "lucide-react";

import { DBTablesType } from "@libs/authorization";
import { I18nKeyType } from "@libs/i18n";

type MenuType = {
  title: I18nKeyType;
  url: LinkProps["to"];
  icon: ReactElement;
  isGroup?: boolean;
  types?: DBTablesType[];
  children?: {
    title: I18nKeyType;
    url: LinkProps["to"];
    type?: DBTablesType;
  }[];
}[];

export const sidebar: MenuType = [
  {
    title: "main:sidebar.dashboard",
    url: "/admin",
    icon: <AppWindow />,
  },
  {
    title: "main:sidebar.registrations",
    url: "/admin/registrations",
    types: ["enrolments"],
    icon: <Copy />,
  },
  {
    title: "main:sidebar.calendars",
    url: "/admin/calendars",
    types: ["events", "enrolments"],
    icon: <Calendar1 />,
  },
  {
    title: "main:sidebar.classrooms",
    url: "/admin/classrooms",
    types: ["events", "enrolments"],
    icon: <MonitorCheck />,
  },
  {
    title: "main:sidebar.enrolments",
    url: "/admin/enrolments",
    types: ["events", "enrolments"],
    icon: <Combine />,
  },
  {
    title: "main:sidebar.invoices",
    url: undefined,
    icon: <ReceiptText />,
  },
  {
    title: "main:sidebar.payments",
    url: undefined,
    icon: <TableProperties />,
  },
  {
    title: "main:sidebar.people",
    url: undefined,
    icon: <NotebookPen />,
    isGroup: true,
    types: ["staff", "students", "payers"],
    children: [
      {
        title: "main:sidebar.peopleChildren.students",
        url: "/admin/students",
        type: "students",
      },
      {
        title: "main:sidebar.peopleChildren.staff",
        url: "/admin/staff",
        type: "staff",
      },
      {
        title: "main:sidebar.peopleChildren.payers",
        url: "/admin/payers",
        type: "payers",
      },
    ],
  },
  {
    title: "main:sidebar.resources",
    url: undefined,
    icon: <TableProperties />,
    isGroup: true,
    types: ["courses", "locations", "document_types", "vehicles"],
    children: [
      { title: "main:sidebar.resourcesChildren.campuses", url: undefined },
      {
        title: "main:sidebar.resourcesChildren.locations",
        url: "/admin/locations",
        type: "locations",
      },
      {
        title: "main:sidebar.resourcesChildren.vehicles",
        url: "/admin/vehicles",
        type: "vehicles",
      },
      {
        title: "main:sidebar.resourcesChildren.courses",
        url: "/admin/courses",
        type: "courses",
      },
      {
        title: "main:sidebar.resourcesChildren.documentTypes",
        url: "/admin/document-types",
        type: "document_types",
      },
      {
        title: "main:sidebar.resourcesChildren.products",
        url: "/admin/products",
        type: "products",
      },
      { title: "main:sidebar.resourcesChildren.contracts", url: undefined },
      { title: "main:sidebar.resourcesChildren.invoices", url: undefined },
    ],
  },
  {
    title: "main:sidebar.reports",
    url: "/admin/reports",
    icon: <BarChart3 />,
  },
  {
    title: "main:sidebar.settings",
    url: undefined,
    icon: <Settings />,
    isGroup: true,
    children: [
      { title: "main:sidebar.settingsChildren.glCodes", url: undefined },
      { title: "main:sidebar.settingsChildren.payerGroups", url: undefined },
    ],
  },
];
